// @ts-nocheck
import Detail from 'app/features/Detail';
import React from 'react';
import Head from 'next/head';
import { makeStore } from 'reducers/store';
import { GraphQLAPI } from 'utils/RTKGraphQL';

export async function getStaticPaths() {
  const store = makeStore();

  const results = await store.dispatch(
    GraphQLAPI.endpoints.getArticles.initiate()
  );

  const paths = results.data
    ? results.data.map((post) => ({
        params: { slug: post.slug },
      }))
    : [];

  return { paths, fallback: 'blocking' };
}

export async function getStaticProps({ params }) {
  const slug = params.slug;

  const store = makeStore();

  const { data: article } = await store.dispatch(
    GraphQLAPI.endpoints.getArticleBySlug.initiate(slug)
  );

  if (!article) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      article,
    },
  };
}

const WrappedDetail = ({ article }) => {
  return (
    <>
      <Head>
        <meta name="description" content={article.description} />
        <meta property="og:title" content={article.title} />
        <meta property="og:description" content={article.description} />
        <meta property="og:image" content={article.image} />
        <meta
          property="og:url"
          content={`https://pandaist.com/${article.slug}`}
        />
        <meta property="og:type" content="article" />
        <meta property="og:locale" content={'en_US'} />
        <meta name="twitter:title" content={article.title} />
        <meta name="twitter:description" content={article.description} />
        <meta name="twitter:image" content={article.image} />
        <meta name="twitter:card" content="summary_large_image" />
        <title>{article.title}</title>
      </Head>
      <Detail article={article} />
    </>
  );
};

export default WrappedDetail;
